import React from 'react';
import { Box, List, ListItem, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import CollapsibleCard from '../common/CollapsibleCard';
import { useAppSelector, useAppDispatch } from '../../store';
import { toggleWhatSystemDoes } from '../../store/slices/uiSlice';

const FEATURES = [
  {
    title: '3–5 day scramble → ~2 minutes:',
    description: 'the agent ingests deviations, calls the right tools, and optimizes automatically.',
  },
  {
    title: 'Handles messy deviations:',
    description: 'multi-batch cannibalization, shortages with tiered fairness, and mixed events in one pass.',
  },
  {
    title: 'Transparency you can act on:',
    description: 'what-if comparisons, excluded-region explanations, and approval workflow keep humans in control.',
  },
];


const WhatSystemDoesCard: React.FC = () => {
  const dispatch = useAppDispatch();
  const expanded = useAppSelector((state) => state.ui.whatSystemDoesExpanded);

  return (
    <CollapsibleCard
      title="What this system does"
      icon={<InfoIcon sx={{ fontSize: 18 }} />}
      expanded={expanded}
      onToggle={() => dispatch(toggleWhatSystemDoes())}
    >
      <List sx={{ padding: 0, margin: 0 }}>
        {FEATURES.map((feature, index) => (
          <ListItem
            key={index}
            sx={{
              padding: '6px 0 6px 0',
              position: 'relative',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1,
            }}
          >
            <Typography
              component="span"
              sx={{
                color: 'success.main',
                fontWeight: 'bold',
                fontSize: '14px',
                lineHeight: 1.5,
              }}
            >
              ✓
            </Typography>
            <Box>
              <Typography
                component="span"
                sx={{
                  fontWeight: 600,
                  color: '#1a1a2e',
                  fontSize: '13px',
                  lineHeight: 1.5,
                }}
              >
                {feature.title}
              </Typography>{' '}
              <Typography
                component="span"
                sx={{
                  color: '#4a4a4a',
                  fontSize: '13px',
                  lineHeight: 1.5,
                }}
              >
                {feature.description}
              </Typography>
            </Box>
          </ListItem>
        ))}
      </List>
    </CollapsibleCard>
  );
};

export default WhatSystemDoesCard;
